export default __webpack_public_path__ + "static/media/fallback.a87f9330.jpeg";